import { refresh } from '../utils';
import {
  errorRoute, purchaseProcessingRoute, initPurchaseAuthRoute, appInstallationRoute,
} from './shared';

export default [
  errorRoute,
  purchaseProcessingRoute,
  initPurchaseAuthRoute,
  appInstallationRoute,
  {
    name: 'home',
    path: '/',
    component: () => refresh(import('@/views/Home.vue')),
  },
  {
    path: '/app/:type/:id',
    component: () => refresh(import('@/views/App.vue')),
    redirect: () => ({ path: '/', query: {} }),
  },
  {
    name: 'app-details',
    path: '/details/:id',
    component: () => refresh(import('@/views/Details/index.vue')),
  },
  {
    name: 'app-download',
    path: '/details/:id/download',
    component: () => refresh(import('@/views/Details/Download.vue')),
  },
  {
    name: 'search',
    path: '/search',
    component: () => refresh(import('@/views/Search.vue')),
    redirect: () => ({ path: '/', query: {} }),
  },
  {
    name: 'index',
    path: '/index',
    component: () => refresh(import('@/views/Index.vue')),
  },
  {
    path: '/news/:id?',
    component: () => refresh(import('@/views/News.vue')),
  },
  {
    path: '/requests',
    name: 'requests',
    component: () => refresh(import('@/views/Requests/index.vue')),
  },
  {
    path: '/link',
    component: () => refresh(import('@/views/Link')),
  },
  {
    path: '/link-qr',
    component: () => refresh(import('@/views/LinkQR.vue')),
  },
  {
    path: '/link/tv',
    component: () => refresh(import('@/views/Link/TV.vue')),
  },
  {
    path: '/link/confirm',
    component: () => refresh(import('@/views/Link/Confirm.vue')),
  },
  {
    path: '/banned',
    component: () => refresh(import('@/views/Banned.vue')),
  },
  {
    path: '/redirect/:ticket',
    component: () => refresh(import('@/views/Redirect.vue')),
  },
  {
    name: 'ban',
    path: '/ban',
    component: () => refresh(import('@/views/Banned.vue')),
    props: true,
  },
  {
    name: 'success',
    path: '/success',
    component: () => refresh(import('@/views/Success.vue')),
    props: true,
  },
  {
    path: '/my',
    redirect: '/my/devices',
    component: () => refresh(import('@/views/My')),
    children: [
      {
        path: 'devices',
        component: () => refresh(import('@/views/My/Devices.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'status',
        component: () => refresh(import('@/views/My/Status.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'updates',
        component: () => refresh(import('@/views/My/Updates.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'configure',
        component: () => refresh(import('@/views/My/Configure.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'unlink',
        component: () => refresh(import('@/views/My/Unlink.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        name: 'my-apps',
        path: 'apps',
        component: () => refresh(import('@/views/My/Apps/index.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        name: 'my-installation-history',
        path: 'installation-history',
        component: () => refresh(import('@/views/My/InstallationHistory/InstallationHistory.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'dylibs',
        component: () => refresh(import('@/views/My/Dylibs.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'repos',
        component: () => refresh(import('@/views/My/Repos.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'repos/import',
        redirect: to => ({ path: '/repos/import', query: to.query }),
      },
      {
        path: 'error',
        component: () => refresh(import('@/views/My/Error.vue')),
        meta: {
          authRequired: false,
        },
      },
      {
        path: 'buy',
        redirect: 'faq',
        meta: {
          authRequired: false,
        },
      },
      {
        path: 'faq',
        component: () => refresh(import('@/views/My/Faq.vue')),
        meta: {
          authRequired: false,
        },
      },
      {
        path: 'billing',
        component: () => refresh(import('@/views/My/Billing/index.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'plus',
        component: () => refresh(import('@/views/My/Plus.vue')),
        meta: {
          authRequired: false,
        },
      },
      {
        path: 'premium',
        component: () => refresh(import('@/views/My/Premium.vue')),
        meta: {
          authRequired: false,
        },
      },
      {
        path: 'apple',
        component: () => refresh(import('@/views/My/Apple.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'free-apple',
        component: () => refresh(import('@/views/My/FreeApple.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'roulette',
        component: () => refresh(import('@/views/My/Roulette.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'referrals',
        component: () => refresh(import('@/views/My/Referrals.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'p2p-certificates',
        component: () => refresh(import('@/views/My/P2PCertificates.vue')),
      },
      {
        path: 'change-email',
        component: () => refresh(import('@/views/My/ChangeEmail.vue')),
      },
      {
        path: 'support',
        component: () => refresh(import('@/views/My/Support.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'support/discussion=:id',
        component: () => refresh(import('@/views/SupportDiscussion.vue')),
        meta: {
          authRequired: true,
        },
      },
      {
        path: 'auto-reimbursement',
        component: () => refresh(import('@/views/AutoReimbursement.vue')),
        meta: {
          authRequired: false,
        },
        children: [
          {
            path: 'devices',
            component: () => refresh(import('@/views/AutoReimbursement.vue')),
            meta: {
              authRequired: true,
            },
          },
          {
            path: 'withdrawals',
            component: () => refresh(import('@/views/AutoReimbursement.vue')),
            meta: {
              authRequired: true,
            },
          },
        ],
      },

    ],
  },
  {
    path: '/repos',
    component: () => refresh(import('@/views/Repos')),
  },
  {
    path: '/repos/import',
    component: () => refresh(import('@/views/Repos/Import.vue')),
  },
  {
    path: '/repos/:id',
    component: () => refresh(import('@/views/Repos/Repo.vue')),
  },
  {
    path: '/repos/:repoId/app/:id',
    component: () => refresh(import('@/views/App.vue')),
  },
  {
    name: 'p2p-discussion',
    path: '/p2p/discussion',
    component: () => refresh(import('@/views/P2PDiscussion.vue')),
  },
  {
    path: '/info/api',
    component: () => refresh(import('@/views/Info/Api.vue')),
  },
  {
    path: '/info/privacy',
    component: () => refresh(import('@/views/Info/Privacy.vue')),
  },
  {
    path: '/info/tos',
    component: () => refresh(import('@/views/Info/Tos.vue')),
  },
  {
    path: '/info/about',
    component: () => refresh(import('@/views/Info/About.vue')),
  },
  {
    path: '/info/empire-strikes-back',
    component: () => refresh(import('@/views/Info/Empire.vue')),
  },
  {
    path: '/my/support',
    component: () => refresh(import('@/views/My/Support.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/my/support/discussion=:id',
    component: () => refresh(import('@/views/SupportDiscussion.vue')),
    meta: {
      authRequired: true,
    },
  },
  {
    path: '/appdb-tools',
    component: () => refresh(import('@/views/AppdbTools.vue')),
  },
  {
    path: '/appdb-jitpair',
    component: () => refresh(import('@/views/AppdbJitpair.vue')),
  },
  {
    path: '/enable-jit',
    component: () => refresh(import('@/views/EnableJit.vue')),
  },
  {
    path: '/articles/:id',
    component: () => refresh(import('@/views/Article.vue')),
  },
  {
    path: '/plus-required',
    component: () => refresh(import('@/views/PlusRequired.vue')),
  },
  {
    path: '/init-purchase',
    component: () => refresh(import('@/views/InitPurchase.vue')),
    meta: {
      layout: 'empty',
    },
  },
  {
    name: '404',
    path: '*',
    redirect: {
      name: 'error',
      params: {
        message: 'We were unable to find such page.',
        link: '/',
        linkText: 'GO_TO_MAIN_PAGE',
      },
    },
  },
];
